import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { AppServerAPI } from '@sdbn/common';
import { environment } from "src/environments/environment";
import { ArticleType } from "./article-type.model";
import { TranslationService } from "@sdbn/common";

@Injectable({
  providedIn: 'root'
})
export class ArticleTypeService {

  initialized = false;

  articleTypes = new Array<ArticleType>();

  changed$ = new Subject<void>();

  constructor(
    private appServerAPI: AppServerAPI,
    private translationService: TranslationService
  ) {
    this.refreshData();
  }

  public refreshData() {

    this.appServerAPI.execute<ArticleType[]>('/client/erp-article/article-type/getAllArticleTypes', {}).subscribe(response => {

      console.log('response for refreshing data is', response);

      let data = new Array<ArticleType>();

      for (let articleTypeItem of response) {
        const articleType = new ArticleType(articleTypeItem).linkDetails();
        articleType.calculateTitle(this.translationService.language);
        data.push(articleType);
      }

      this.articleTypes = data;

      console.log('notifying observers');
      this.initialized = true;
      this.changed$.next();
    }, error => {
      console.log('error is', error);
    });



  }

  public getNonArchived(): Array<ArticleType> {
    if (this.articleTypes == null ) {
      return new Array<ArticleType>();
    }
    return this.articleTypes.filter(articleType => articleType.archived === false);
  }

  public getById(id: number): ArticleType {
    for (let articleType of this.articleTypes) {
      if (articleType.id === id) {
        return articleType;
      }
    }
    return null;
  }

}

